import { useQuery } from "@tanstack/react-query";
import { getOrCreateShortLink } from "@/lib/public-helpers.functions";

/** A path that is already a short code, e.g. "/h637hx" — nothing to shorten. */
const ALREADY_SHORT = /^\/[a-z0-9]{4,8}$/;

/**
 * Returns a short path ("/ab3k9x") for any same-site page path, creating it on
 * first use. Falls back to the original path while loading or on failure, so
 * sharing always works.
 */
export function useShortLink(path: string) {
  const shareable = path.startsWith("/") && !ALREADY_SHORT.test(path);

  const { data } = useQuery({
    queryKey: ["short-link", path],
    enabled: shareable,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
    queryFn: async () => {
      const { code } = await getOrCreateShortLink({ data: { path } });
      if (!code) return null;
      return `/${code}`;
    },
  });

  return data ?? path;
}
